import { render } from "./Friend.vue?vue&type=template&id=0fcdefb6&scoped=true&ts=true"
import script from "./Friend.vue?vue&type=script&setup=true&lang=ts"
export * from "./Friend.vue?vue&type=script&setup=true&lang=ts"

import "./Friend.vue?vue&type=style&index=0&id=0fcdefb6&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcdefb6"],['__file',"src/views/friend/Friend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0fcdefb6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0fcdefb6', __exports__)) {
    console.log('reload')
    api.reload('0fcdefb6', __exports__)
  }
  
  module.hot.accept("./Friend.vue?vue&type=template&id=0fcdefb6&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('0fcdefb6', render)
  })

}


export default __exports__